/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products */
  static #STORAGE_KEY = 'recently_viewed_products';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 10;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getRawProducts();

    viewedProducts = viewedProducts.filter((item) => {
      const id = typeof item === 'object' ? String(item.id) : String(item);
      return id !== String(productId);
    });

    viewedProducts.unshift({ id: Number(productId), collection: '' });
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the raw list of recently viewed products.
   * @returns {any[]} The raw list.
   */
  static getRawProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }

  /**
   * Retrieves the list of recently viewed product IDs as strings.
   * @returns {string[]} The list of viewed product IDs.
   */
  static getProducts() {
    return this.getRawProducts().map((item) => {
      const id = typeof item === 'object' ? item.id : item;
      return String(id);
    });
  }
}
